<style lang="scss" scoped>
.query-form-div {
  padding: 12px;
}

.body-div {
  padding: 12px;
}

.pagination-div {
  padding: 12px;
  text-align: right;
}

.handle-div {
  padding: 12px;
  text-align: right;
}
</style>
<template>
  <div v-loading="allLoading" element-loading-text="数据加载中...">
    <div class="query-form-div">
      <el-button icon="el-icon-plus" size="small" @click="showEditDialog(null)">添加</el-button>
    </div>
    <div class="body-div">
      <el-table :data="refereeTypes" style="width: 100%" stripe size="mini" border>
        <el-table-column label="类型名称" prop="RefereeTypeName"  width="250">
        </el-table-column>
       
        <el-table-column label="类型职责" prop="RefereeResponsibility">
          <template slot-scope="scope">
            <el-tag size="mini" style="margin: 2px;" v-for="item in scope.row.RefereeResponsibilityArr">{{ item }}</el-tag>
          </template>
        </el-table-column>
         <el-table-column label="类型描述" prop="RefereeTypeDescribe">
        </el-table-column>
        <el-table-column label="操作" width="200px">
          <template slot-scope="scope">
            <i style="font-size:16px;margin: 5px;cursor: pointer;" class="el-icon-edit"
              @click="showEditDialog(scope.row)"></i>
            <i style="font-size:16px;margin: 5px;cursor: pointer;color: red;" class="el-icon-delete"
              @click="delItem(scope.row)"></i>
            <i v-if="scope.$index > 0" style="font-size:16px;margin: 5px;cursor: pointer;" class="el-icon-zhiding"
              @click="toTop(scope.$index)"></i>
            <i v-if="scope.$index > 0" style="font-size:16px;margin: 5px;cursor: pointer;" class="el-icon-caret-top"
              @click="toUpper(scope.$index)"></i>
            <i v-if="scope.$index < refereeTypes.length - 1" style="font-size:16px;margin: 5px;cursor: pointer;"
              class="el-icon-caret-bottom" @click="toDown(scope.$index)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="编辑" :visible.sync="editDialogVisible" width="1200px">

      <div style="width: 90%;margin: 0 auto;">
        <el-form :model="editForm" ref="editForm" :rules="editFormRule" label-width="100px">
          <el-form-item prop="RefereeTypeName" label="类型名称">
            <el-input v-model="editForm.RefereeTypeName"></el-input>
          </el-form-item>
          <el-form-item label="类型描述">
            <el-input type="textarea" v-model="editForm.RefereeTypeDescribe"></el-input>
          </el-form-item>
          <el-form-item label="类型职责">
            <div v-for="ts in jobTypes" style="margin: 5px;">
              <p style="margin: 5px 0; "> {{ ts.GroupName }}</p>
              <el-checkbox-group v-model="editForm.RefereeResponsibilityArr">
                <el-checkbox style="margin-bottom: 10px;" v-for="job in ts.Items" :label="job.value" :key="job.value">{{
                  job.label
                }}</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="submitEdit">确 定</el-button>
        <el-button size="small" @click="editDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>


  </div>
</template>
<script>
import matchService from "@/request-server/request-services/match-services.js";
import utilsCommon from '../../../utils/utils-common';
import refereeJobTypes from '@/data/referee-job-types.js';
export default {
  data() {
    return {
      allLoading: false,
      editDialogVisible: false,
      qForm: {
        RefereeTypeName: ""
      },
      editForm: {
        RefereeTypeId: '',
        RefereeTypeName: '',
        RefereeTypeDescribe: '',
        RefereeTypeSort: 0,
        RefereeResponsibility: '',
        RefereeResponsibilityArr: []
      },
      editFormRule: {
        RefereeTypeName: [
          { required: true, message: '请输入类型名称', trigger: 'blur' }
        ],
      },
      refereeTypes: [],
      jobTypes: refereeJobTypes.JobTypes,
    };
  },
  created() {
    this.query();
  },
  methods: {

    query() {
      this.allLoading = true;
      matchService.selectRefereeTypeList().then((res) => {
        this.allLoading = false;
        if (res.code == 0) {
          this.refereeTypes = res.data;
          this.refereeTypes.forEach(type => {
            if (type.RefereeResponsibility) {
              type['RefereeResponsibilityArr'] = type.RefereeResponsibility.split(',');
            } else {
              type['RefereeResponsibilityArr'] = [];
            }
          })
          console.log(this.refereeTypes);
        }
      });
    },
    showEditDialog(data) {
      console.log(data);
      if (data) {
        this.editForm = {
          RefereeTypeId: data.RefereeTypeId,
          RefereeTypeName: data.RefereeTypeName,
          RefereeTypeDescribe: data.RefereeTypeDescribe,
          RefereeTypeSort: data.RefereeTypeSort,
          RefereeResponsibility: data.RefereeResponsibility,
          RefereeResponsibilityArr: data.RefereeResponsibilityArr,
          CreateTime: data.CreateTime,
          IsDel: data.IsDel
        };
      } else {
        this.editForm = {
          RefereeTypeId: '',
          RefereeTypeName: '',
          RefereeTypeDescribe: '',
          RefereeTypeSort: 0,
          RefereeResponsibility: '',
          RefereeResponsibilityArr: []
        }
      }
      this.editDialogVisible = true;
    },
    submitEdit() {
      this.$refs["editForm"].validate(valid => {
        if (valid) {
          if (this.editForm.RefereeResponsibilityArr) {
            //排序职责
            let jobArr = [];
            this.editForm.RefereeResponsibility = '';
            console.log(this.jobTypes);
            this.jobTypes.forEach(a => {
              a.Items.forEach(job => {
                jobArr = [...jobArr, job.value];
              })

            });

           
            let arr = [];
            jobArr.forEach(job => {
              if (this.editForm.RefereeResponsibilityArr.indexOf(job) > -1) {
                arr.push(job);
              }
            })
            this.editForm.RefereeResponsibility = arr.join(',');
          } else {
            this.editForm.RefereeResponsibility = '';
          }


          matchService.editRefereeTypeInfo([this.editForm]).then(res => {
            console.log(res);
            if (res.code == 0) {
              this.$message.success(res.data);
              this.editDialogVisible = false;
              this.query();
            }
          })

        }
      })
    },
    delItem(row) {
      this.$confirm('确定删除该类型吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {
          RefereeTypeId: row.RefereeTypeId,
          RefereeTypeName: row.RefereeTypeName,
          RefereeTypeDescribe: row.RefereeTypeDescribe,
          RefereeTypeSort: row.RefereeTypeSort,
          RefereeResponsibility: row.RefereeResponsibility,
          RefereeResponsibilityArr: row.RefereeResponsibilityArr,
          CreateTime: row.CreateTime,
          IsDel: 1
        };
        matchService.editRefereeTypeInfo([data]).then(res => {
          if (res.code == 0) {
            this.$message.success('删除成功');
            this.query();
          }
        })

      })
    },
    toTop(index) {
      let arr = utilsCommon.copyObj(this.refereeTypes);
      let row = arr[index];
      //删除该项
      arr.splice(index,1);
      arr.splice(0,0,row);
      console.log(arr)

      for (let idx = 0; idx < arr.length; idx++) {
        arr[idx].RefereeTypeSort = idx + 1;
      }
      this.requestEdit(arr);
    },
    toUpper(index){
      let arr = utilsCommon.copyObj(this.refereeTypes);
      let sort1 = arr[index].RefereeTypeSort;
      let sort2 = arr[index - 1].RefereeTypeSort;

      arr[index].RefereeTypeSort = sort2;
      arr[index - 1].RefereeTypeSort = sort1;

      this.requestEdit(arr);

    },
    toDown(index){
      let arr = utilsCommon.copyObj(this.refereeTypes);
      let sort1 = arr[index].RefereeTypeSort;
      let sort2 = arr[index + 1].RefereeTypeSort;

      arr[index].RefereeTypeSort = sort2;
      arr[index + 1].RefereeTypeSort = sort1;

      this.requestEdit(arr);
    },
    requestEdit(data) {
      matchService.editRefereeTypeInfo(data).then(res => {
        console.log(res);
        if (res.code == 0) {
          this.$message.success(res.data);
          this.query();
        }
      })
    }
  },
  computed: {

  },
};
</script>
